// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import TrademarkCircleTwoToneSvg from "@fishx/icons-svg/es/asn/TrademarkCircleTwoTone";
import FishxIcon from '../components/FishxIcon';

var TrademarkCircleTwoTone = function TrademarkCircleTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: TrademarkCircleTwoToneSvg
  }));
};

TrademarkCircleTwoTone.displayName = 'TrademarkCircleTwoTone';
export default React.forwardRef(TrademarkCircleTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/TrademarkCircleTwoTone.js
// module id = 4273
// module chunks = 0